import { fm } from 'Components/FormatMessage';
import { TESSearchField, TESSearchFields } from '../definitions';
import { diagnosesByPlatform } from '../functions/constants/diagnoses';
import { TEpilepsyESSearchFields } from '../definitions/epilepsy';

export const epilepsyExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'diagnosis',
    type: 'MultiSelect',
    options: diagnosesByPlatform.epilepsy,
    optionFormatter: (name: string | number): string | React.JSX.Element => {
      return `${name}`;
    },
    tooltips: diagnosesByPlatform.epilepsy?.map((diagnosis, index) => ({
      index,
      message: fm(`diagnosis.opts.${diagnosis}`),
    })),
    style: { display: 'flex', justifyContent: 'center', width: '7rem' },
  },
  {
    name: 'diagnosisDate',
    type: 'Custom',
  },
  {
    name: 'seizureClassification',
    type: 'Custom',
  },
  {
    name: 'syndrome',
    type: 'Custom',
  },
  {
    name: 'etiology',
    type: 'Custom',
  },
  {
    name: 'seizureFrequency',
    type: 'Custom',
  },
  {
    name: 'medication',
    type: 'Custom',
  },
  {
    name: 'substance',
    type: 'Custom',
  },
  {
    name: 'vnsTreatment',
    type: 'Custom',
  },
  {
    title: 'dbsTreatment',
    name: 'epilepsyDbsTreatment',
    type: 'Custom',
  },
  {
    name: 'surgicalTreatment',
    type: 'Custom',
  },
  {
    name: 'dietTherapy',
    type: 'Checkbox',
    options: ['ongoing', 'ended'],
  },
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];

export const defaultEpilepsySearchValues: TEpilepsyESSearchFields = {
  surgicalTreatment: 'noCropping',
  seizureClassification: 'noCropping',
  syndrome: 'noCropping',
  etiology: 'noCropping',
  seizureFrequency: 'noCropping',
  vnsTreatment: 'noCropping',
  epilepsyDbsTreatment: 'noCropping',
  dietTherapy: 'noCropping',
};
